<div [style.display]="'block'">
  <div *ngFor="let item of itemsDetailList">
    <mat-card appearance="outlined">
      <mat-card-header tabindex="0" (keyup.enter)="itemSelect(item)" (click)="itemSelect(item)" [ngClass]="'ta-itemlist-'+item.id">
        <div mat-card-avatar *ngIf="!forSalesOrder" class="fa fa-shopping-basket fa-3x"></div>
        <mat-card-title>{{item.name}} - ({{item.id}})</mat-card-title>
        <mat-card-subtitle>
          <div class="container">
            <div class="row"> Price: {{item.price}} / {{item.defaultSellingUom}} </div>
            <div *ngIf="item.isOnHandAndPositionLoaded" class="row"> On Hand: {{item.itemBalance.OnHandQuantity |
              number:'1.0-1'}} </div>
            <div *ngIf="!item.isOnHandAndPositionLoaded" class="row"> On Hand: Loading... </div>
            <div *ngIf="item.isOnHandAndPositionLoaded" class="row"> Position: {{item.itemBalance.PositionQuantity |
              number:'1.0-1'}} </div>
            <div *ngIf="!item.isOnHandAndPositionLoaded" class="row"> Position: Loading... </div>
          </div>
        </mat-card-subtitle>
      </mat-card-header>
      <mat-card-footer>
        <button class="mdc-button-whiteBackground  ta-itemlist-quantitybylocation" *ngIf="showLocationDetails" mat-button color="primary"
          (click)="showOnhandOnOtherLocations(item)">Quantity
          by location</button>
        <!-- <button class="ta-itemlist-quantitybylocation" mat-button color="primary"
          (click)="showOnhandOnOtherLocations(item)">Quantity
          by location</button> -->
      </mat-card-footer>
    </mat-card>
    <br>
  </div>
</div>

<!-- "showRecords ? 'block' : 'none'" -->